export default "__VITE_PUBLIC_ASSET__5d1b0651__"